import {Stack} from '@mui/system';
import styled from 'styled-components';

const Container = styled(Stack)`
	width: 100%;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;

export {Container};
